
  import { mapState, mapGetters } from 'vuex'
  import playerProfile from '~/mixins/common/pages/player-profile'
  export default {
    name: 'Theme2DesktopProfilesUserPersonalDetail',
    mixins: [playerProfile],
    data() {
      return {
        deleteLoading: {},
        formValid: false,
        emptySocial: [],
        formData: {
          currency: '',
          email: '',
          phone: '',
          date_of_birth: null,
          address: '',
          social_info: [
            {
              id: null,
              social_media_type: null,
              social_media_id: ''
            }
          ]
        },
        existForm: {},
        isBirthdateAlreadyAdded: false,
        isAddressAlreadyAdd: true
      }
    },
    computed: {
      ...mapGetters({
        loading: 'themes/player/loading'
      }),
      ...mapState({
        loadingPlayer: state => state.player.loading,
        player: state => state.player.player
      }),
      isMatch() {
        const isChangeAddress =
          String(this.formData?.address || '') === String(this.existForm?.address || '')
        const isChangeDate =
          String(this.formData?.date_of_birth || '') === String(this.existForm?.date_of_birth || '')

        const isChangeEmail =
          String(this.formData?.email || '') === String(this.existForm?.email || '')

        const isDisable = this.isEqual(this.formData, this.existForm)

        return isDisable && isChangeAddress && isChangeEmail && isChangeDate
      },
      hasActiveDeletion() {
        return Object.values(this.deleteLoading).some(val => val);
      }
    },
    watch: {
      player(value) {
        this.setFormDataDefaultVal(value)
      }
    },
    mounted() {
      this.setFormDataDefaultVal(this.player)
    },
    beforeDestroy() {
      this.doCancelAxiosRequest()
    },
    methods: {
      addNewSocialItem() {
        if (this.formData?.social_info?.length >= 6) return
        this.formData?.social_info?.push({
          id: null,
          social_media_type: null,
          social_media_id: ''
        })
      },
      async deleteSocialItem(item, index) {
        this.$set(this.deleteLoading, item.id, true)

        try {
          if (item.id) {
            if (window.confirm(this.tl('areYouSure'))) {
              this.emptySocial = this.formData?.social_info?.length > 1 ?
                this.formData.social_info.filter((item)=>item.id===null || item.id==='') : [];
              const result = await this.$store.dispatch('themes/player/doDeleteSocial', item.id)
              if (result) {
                this.$delete(this.formData?.social_info, index);
              }
              else{
                this.emptySocial = []
              }
            }
          } else {
            this.$delete(this.formData?.social_info, index)
          }
        } finally {
          this.$set(this.deleteLoading, item.id, false)
        }
      },
      setFormDataDefaultVal(player) {
        if (!player) return
        const socialInfo = JSON.parse(JSON.stringify(player));
        const formData = {
          currency: socialInfo?.currency || '',
          email: socialInfo?.email || '',
          phone: socialInfo?.phone || '',
          date_of_birth: socialInfo?.date_of_birth || null,
          address: socialInfo?.address || '',
          social_info: socialInfo?.social_info?.length
            ? JSON.parse(JSON.stringify(socialInfo?.social_info))
            : [
                {
                  id: null,
                  social_media_type: null,
                  social_media_id: ''
                }
              ]
        }
        if (formData?.date_of_birth) {
          this.isBirthdateAlreadyAdded = true
        }

        if (!formData?.address || formData.address.trim() === '') {
          this.isAddressAlreadyAdd = false
        } else {
          this.isAddressAlreadyAdd = true
        }


        this.existForm = JSON.parse(JSON.stringify(formData))
        
        if(this.emptySocial?.length > 0){
          const newSocials = formData?.social_info?.length > 0 && formData.social_info?.[0].id !== null;
          
          if(newSocials){
            formData.social_info.push(...this.emptySocial)
          }
          else{
            formData.social_info = this.emptySocial;
          }
        }

        this.formData = JSON.parse(JSON.stringify(formData))
        this.emptySocial = [];
      },
      setDate(date) {
        this.formData.date_of_birth = date.trim()
      },
      socialChange(index) {
        const socials = this.formData?.social_info
        const currentSocial = socials[index]
        for (let idx = 0; idx < socials.length; idx++) {
          if (idx === index) continue
          const social = socials[idx]
          if (currentSocial?.social_media_type === social?.social_media_type) {
            this.formData.social_info[index].social_media_type = null
            this.$forceUpdate()
            break
          }
        }
      }
    }
  }
